module.exports = __webpack_public_path__ + "static/newbornLogoFull-01ecfc09a7a6400bf0aa868619dc8159.png";